/*
* 班牛群组数据格式化
*
* */
import cityMap from './request'
/*
* 整理群组信息数据格式 参数 data：后台返回的群组信息   $rootScope.user.userList：全局储存的公司成员总量
* */
export function formattingProjectInfo (data,users,sellers) {
  let project = {
    projectId: data.id.toString(),//群组ID
    title: data.title ? data.title : '未命名~',//群组名称
    md5Sign: data.md5Sign ? data.md5Sign : '',//群组md5加密码
    alarmTime: data.alarmTime ? data.alarmTime : 1,//1: 不提醒; 2: 自定义; 15: 提前15分钟; 30: 提前30分钟; 60: 提前1个小时; 120: 提前2个小时; 180: 提前3个小时; 360: 提前6个小时; 480: 提前8个小时; 1440: 提前一天
    defaultTaskTitle: data.defaultTaskTitle ? data.defaultTaskTitle : '', //任务标题 绑定到的组件id
    description: data.description ? data.description : '暂无描述',//群组描述
    gmtCreate: data.gmtCreate ? data.gmtCreate : '',//群组创建时间
    hasSeller: data.hasSeller ? data.hasSeller : '',// ?
    isAutoAssign: data.isAutoAssign ? data.isAutoAssign : '0',// 是否开启自动分配任务 0关闭任务分配 1 开启平均分配 2 开始规则分配
    isDelete: data.isDelete ? data.isDelete : '',// ?
    projectColor: data.projectColor ? data.projectColor : '',//群组标识颜色
    /*群组类型
    1：普通群  banniu.projectAdvance
    2：负面评价群  banniu.projectNegative
    3：退款群 banniu.projectRefund
    4：人工智能评价群 banniu.projectEvaluate
    5：异常物流群 banniu.projectLogistic
    6：未评订单应用群 banniu.projectNorate 已下线
    7：备注订单群 banniu.projectRemark
    8：ERP商品退换补群 banniu.projectReplacement
    10：子表单的关联数据群 banniu.projectAdvance 一种特殊的普通群
    * */
    projectType: data.projectType ? data.projectType : 1,
    star: data.star ? data.star : false,//是否是星标群
    projectUsers: [],//群组中的群成员 role: "qz", sortNum: 1, id: 110119744
    sellers: sellers, //群组中绑定的店铺
    projectOwner: {}, // 群主
    currentUser: {}, //当前操作成员
  };
  //判断群组的成员，通过遍历$rootScope.user.userList *全公司成员* 拿到成员的详细信息；
  users.map(user=>{
    let userData ={
      role: user.role ? user.role : 'fk', //成员角色 qz：群主  gly：管理员  cy：成员  fk：自定义角色
      id: user.id, //成员id
      sortNum: user.sortNum, //成员排序字段
      isAdmin: user.isAdmin,//是否是管理员
      jifenSys: user.jifenSys,//是否拥有积分系统的权限
      status: user.status,//？
      userIcon: user.userIcon,//群成员头像
      title:user.workNick,//群成员昵称
    };
    project.projectUsers.push(userData);
  })
  return project;
};
/*
*整理群组任务列表中，群组的组件列表格式 参数
* columnList：后台返回的群组组件列表
* 保证改列表是正常数组*
* cityMap:地址信息静态json
* $rootScope.user.sellerList全局的店铺信息存储
* 需要先获取到群组的 projectUsers
* */
export function formattingColumns (columnList,projectInfo) {
  let sellerList = projectInfo.sellers;
  let columns = []; //定义总存储位置
  //先对组件列表进行排序 获取到正确顺序的组件列表
  let columnListSort = columnList.sort(function (a, b) {
    return a.sortNum - b.sortNum;
  });
  //1. 遍历组件列表 此处使用forEach是因为此处不存在跳出循环的情况，所有组件都需要进行处理
  columnListSort.map(colItem => {
    /*拷贝组件共有的信息到新的对象当中，再根据不同的moduleType来分类处理  moduleType的类型分别请到石墨文档 https://shimo.im/sheet/WglZGboFn8wCDxTA/ 处查看
   *    moduleType是后台重要的组件识别字段，但是前端需要根据moduleType来判断组件的行为，给组件重新定义 behaviorType 行为类型，用来在前端对组件进行统一的区分和管理
   *    以下是前端封装后组件中包含的字段的意义和使用方式
   *    behaviorType：组件行为类型，前端根据组件的行为进行分类和定义  必有
   *    defaultInfo： 组件默认值，后台返回过来的
   *    defaultValue: 根据defaultInfo，遍历子条件，转换成可以直接set到组件value当中的对象值。
   *    value: 组件的值，根据不同的behaviorType类型，存储方式有对象，数组，字符串等类型，在创建任务时，编辑任务改值会是一个不为空null的字段，新建的时候都会是初始化的默认字段
   *    extraInfo：组件权限相关设置 hidden: 1>新建时隐藏 0>新建时不隐藏  component_iseditable: 1>可编辑 0>禁止编辑   is_only: 0> 1> ？
   *    outDataSourceInfo： 组件别名，一般用来判断同一个类型但是有不同性质的组件，这个字段有时是 string 有时候是 array 属于很重要又对前端代码流畅度影响很大的字段
   * */
    let column = {
      name: colItem.name, //组件名称
      moduleType: colItem.moduleType, //组件moduleType
      id: colItem.id,//组件id
      tableId: colItem.tableId,//组件的表id
      sortNum: colItem.sortNum,  //组件的排序
      hidden: colItem.hidden,  // 新建时隐藏
      isDeletable: colItem.isDeletable, // 是否能够删除
      isDisplayed: colItem.isDisplayed, // 任务列表中展示隐藏
      isEditable: colItem.isEditable,  // 是否能够编辑
      isEmptyInputCheck: colItem.isEmptyInputCheck,  //是否必填
    };
    switch (column.moduleType) {
      // case 1: //购物车组件 behaviorType:shoppingCart 》自定义组件位置 js/component/setShoppingCartTask/setShoppingCartTask.js
      // {
      //   column.behaviorType = 'shoppingCart';
      //   column.defaultInfo = colItem.defaultInfo; //购物车没有默认值
      //   column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';//购物车没有别名
      //   column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
      //   column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : '';  //购物车表头和子选项  还有一个 is_show_detail 字段
      //   column.headerInfo = [ //购物车的表头
      //     {title: column.moduleDefinition.headerInfo.item},
      //     {title: column.moduleDefinition.headerInfo.name},
      //     {title: column.moduleDefinition.headerInfo.num + '(' + column.moduleDefinition.headerInfo.unit + ')'}, //名称加上单位，基本上是写死的
      //     {title: '数量'}, {title: '小计'}, {title: '操作'}];
      //   column.optionList = []
      //   column.moduleDefinition.option.map(option=>{
      //     column.optionList.push({
      //       optionId: option.optionId,
      //       cost: option.cost,
      //       number: option.number,
      //       title: option.title,
      //       total: 1
      //     })
      //   })
      //   column.defaultValue = [];
      //   column.value = [];
      //   //保存任务时 购物车的组装格式
      //   // {"moduleType": "1",
      //   // "value": "[{"optionId ":49164,"number ":"1 ","title ":"选项1 ","cost ":"0 ","total ":4},
      //   // {"optionId ":49166,"number ":"3 ","title ":"选项3 ","cost ":"0 ","total ":4},
      //   // {"optionId ":49169,"number ":"4 ","title ":"选项4 ","cost ":"0 ","total ":5}]",
      //   // "oldValue": "",
      //   // "colId": "49163"}
      //   break;
      // }
      //该一类型的组件 都是下拉菜单组件 behavior:select 》自定义组件位置 js/component/bNiuSelect/bNiuSelect.js
      case 2: //店铺组件 子条件拼装需要将 $rootScope.rootSellerList>sellerList 和 moduleDefinition 一前一后拼接到一起 ！没有默认值设置>defaultInfo ！有别名 > outDataSourceInfo: "seller"
      {
        column.behaviorType = 'select';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = sellerList;
        column.defaultValue = {}; // 没有默认值的组件先默认为空
        // column.value = {}; // 没有默认值的组件先默认为空
        // 参数格式 {"moduleType": "2","value": 1827596,"oldValue": "","colId": "49108","outDataSource": "seller"}
        break;
      }
      case 26: //任务执行人 该组件比较特殊，子条件需要从群组信息中获取 projectInfo.projectUsers 中获取过来  有默认值 defaultInfo
      case 28: //任务创建人 该组件比较特殊，子条件需要从群组信息中获取 projectInfo.projectUsers 中获取过来  有默认值 defaultInfo
      {
        column.behaviorType = 'select';
        column.defaultInfo ={};
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = [];
        column.optionList = projectInfo.projectUsers;
        column.defaultValue = {};
        //如果有默认值，则要给组件的默认值遍历出来
        if (column.defaultInfo) {
          for (let i in column.optionList) {
            if (column.optionList[i].id == column.defaultInfo) {
              column.defaultValue = column.optionList[i];
              break;
            }
          }
        }
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        //当群组开启了任务自动分配功能的时候，群组在创建任务的时候，将无法选择 任务执行人的 成员，将直接使用自动分配中设置的成员 projectInfo。isAutoAssign isEmptyInputCheck
        // if (column.moduleType == 26) {
        //   //如果群组开启了自动分配任务  给任务执行人这个组件增加一个特殊值
        //   if (projectInfo.isAutoAssign != '0') {
        //     column.isAutoAssign = true; //表示为任务自动分配
        //   }
        // }
        break;
      }
      case 27: //任务状态  该组件的子条件是直接写死的
      {
        column.behaviorType = 'select';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = [{id: 0, title: '待处理'}, {id: 1, title: '已完成'}, {id: 2, title: '处理中'}, {
          id: 3,
          title: '暂停中'
        }]
        column.defaultValue = {};
        //如果给组件赋默认值
        if (column.defaultInfo != '') {
          for (let i in column.optionList) {
            if (column.optionList[i].id == column.defaultInfo) {
              column.defaultValue = column.optionList[i];
              break;
            }
          }
        }
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      case 5: //优先级组件
      case 17: //下拉菜单组件  有默认值 defaultInfo
      {
        column.behaviorType = 'select';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = column.moduleDefinition;
        column.defaultValue = {};
        //如果给组件赋默认值
        if (column.defaultInfo != '') {
          for (let i in column.optionList) {
            if (column.optionList[i].id == column.defaultInfo) {
              column.defaultValue = column.optionList[i];
              break;
            }
          }
        }
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是字符串组件 behavior:string 》自定义组件位置 js/component/setStringTask/setStringTask.js
      case 3://买家旺旺组件
      case 4://订单号组件
      case 6://多行文本
      case 9: //单行文本
      case 19: //邮箱
      case 20: //编号
      case 21: //银行卡号
      case 25: //任务标题
      case 31: //物流单号
      case 36: //商品标题
      case 37: //商品ID
      case 38: //淘宝、天猫商品sku编码
      case 39: //商品sku属性
      case 40: //商品图片
      case 41: //退款id
      case 42: //子订单运单号
      case 43: //子订单发货快递
      case 44: //商家商品sku编码
      case 50: //款号
      {
        column.behaviorType = 'string';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = column.moduleDefinition;
        column.defaultValue = column.defaultInfo;
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是单选组件 behavior:radio 》自定义组件位置 js/component/setRadioTask/setRadioTask.js
      case 7: //单选
      {
        column.behaviorType = 'radio';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = column.moduleDefinition;
        column.defaultValue = {};
        //如果给组件赋默认值
        if (column.defaultInfo != '') {
          for (let i in column.optionList) {
            if (column.optionList[i].id == column.defaultInfo) {
              column.defaultValue = column.optionList[i];
              break;
            }
          }
        }
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是多选组件 behavior:checkbox 》自定义组件位置 js/component/bNiuCheckbox/bNiuCheckbox.js
      case 8: //多选
      {
        column.behaviorType = 'checkbox';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = column.moduleDefinition;
        column.defaultValue = []; //多选类型的默认值没有存在defaultInfo中，反而在moduleDefinition里面，子条件中 selected为true的默认就是选中
        //如果给组件赋默认值
        if (column.optionList.length > 0) {
          for (let i in column.optionList) {
            if (column.optionList[i].selected) {
              column.defaultValue.push(column.optionList[i]);
              break;
            }
          }
        }
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是数值组件 behavior:number 》自定义组件位置 js/component/setNumberTask/setNumberTask.js
      case 10: //数值
      case 18: //手机号码
      case 22: //金额
      case 46: //商品购买数量
      case 47: //商品单价
      case 24: //评分 该类型组件都是评分组件 behavior:score 》自定义组件位置 js/component/setNumberTask/setNumberTask.js  评分组件虽然行为不同，但是数据格式和数值组件都是一样的
      {
        column.behaviorType = column.moduleType == 24 ? 'score' : 'number';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = column.moduleDefinition;
        column.defaultValue = column.defaultInfo;
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是日期组件 behavior:date 》自定义组件位置 js/component/setDateTask/setDateTask.js
      case 11: //日期
      case 29: //任务创建时间
      case 30: //任务截至时间
      case 32: //任务状态更新时间
      case 33: //修改时间
      {
        column.behaviorType = 'date';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';//时间组件属性show_value_type：date>日期格式 date_time>日期加时间格式; dateDefault：默认值相关(-1>无默认值、0>自定义时间、1>昨天、2>今天、3>明天)
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = column.moduleDefinition;
        column.defaultValue = column.defaultInfo;
        column.dateType = column.extraInfo.show_value_type == 'date' ? column.extraInfo.show_value_type : 'time';
        //根据extraInfo中的组件属性来确认组件的默认值   ！该存默认值的字段不好好存，存到组件属性里面
        if (column.extraInfo.dateDefault >= 0) {
          let formatting = column.extraInfo.show_value_type == 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm';
          switch (column.extraInfo.dateDefault) {
            case 0: { //取defaultInfo中的默认值
              column.defaultValue = column.defaultInfo ? $filter('date')(new Date(column.defaultInfo), formatting) : '';
              break;
            }
            case 1: { //时间取相对日期：昨天
              column.defaultValue = $filter('date')(new Date().setDate(new Date().getDate() - 1), formatting);
              break;
            }
            case 2: {//时间取相对日期：今天
              $filter('date')(new Date(), formatting)
              break;
            }
            case 3: {//时间取相对日期：明天
              column.defaultValue = $filter('date')(new Date().setDate(new Date().getDate() + 1), formatting);
              break;
            }
          }
        }
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是日期区间组件 behavior:dateDual 》自定义组件位置 js/component/setDatedualTask/setDateDualTask.js
      case 12: //日期区间 dateDual
      {
        column.behaviorType = 'dateDual';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';//时间区间组件属性 dateIntervalDefault ：默认值相关(-1>无默认值、0>自定义时间、1>今天、2>近7天、3>近30天、4>当月)
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = column.moduleDefinition;
        column.defaultValue = {start: '', end: ''};
        //根据extraInfo中的组件属性来确认组件的默认值
        if (column.extraInfo.dateIntervalDefault >= 0) {
          let formatting = 'yyyy-MM-dd';
          switch (column.extraInfo.dateDefault) {
            case 0: { //取defaultInfo中的默认值
              if (column.defaultInfo != '') {
                column.defaultValue.start = column.defaultInfo.split(" ~ ")[0]
                column.defaultValue.end = column.defaultInfo.split(" ~ ")[1]
              }
              break;
            }
            case 1: { //时间取相对日期：今天
              column.defaultValue.start = $filter("date")(new Date().setDate(new Date().getDate()), formatting) + ' 00:00';
              column.defaultValue.end = $filter("date")(new Date().setDate(new Date().getDate()), formatting) + ' 23:59';
              break;
            }
            case 2: {//时间取相对日期：近7天
              column.defaultValue.start = $filter("date")(new Date().setDate(new Date().getDate()), formatting) + ' 00:00';
              column.defaultValue.end = $filter("date")(new Date().setDate(new Date().getDate() + 6), formatting) + ' 23:59';
              break;
            }
            case 3: {//时间取相对日期：近30天
              column.defaultValue.start = $filter("date")(new Date().setDate(new Date().getDate()), formatting) + ' 00:00';
              column.defaultValue.end = $filter("date")(new Date().setDate(new Date().getDate() + 29), formatting) + ' 23:59';
              break;
            }
            case 4: {//时间取相对日期：当月
              let nowMonthDays = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
              column.defaultValue.start = $filter("date")(new Date().setMonth(new Date().getMonth(), 1), formatting) + ' 00:00';
              column.defaultValue.end = $filter("date")(new Date().setMonth(new Date().getMonth(), nowMonthDays), formatting) + ' 23:59';
              break;
            }
          }
        }
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是附件组件 behavior:file 》自定义组件位置 js/component/bNiuFile/bNiuFile.js
      case 13: //附件 附件组件需要限制上传文件的大小，上传文件的数量
      {
        column.behaviorType = 'file';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];//[{"name": 49152, "size": 49153, "index": 1, "attachId": 49154}] 附件组件的子条件这里可能写的是组件属性，控制上传的的大小什么的
        column.optionList = column.moduleDefinition;
        column.defaultValue = []; //附件目前没有默认值
        column.value = []; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是联动组件 behavior:relation 》自定义组件位置 js/component/bNiuRelation/bNiuRelation.js
      case 15: //联动组件 （联动组件的参数格式复杂） 无默认值
      case 23: //地址组件 地址组件有默认值
      {
        column.behaviorType = 'relation';
        column.defaultInfo = colItem.defaultInfo ? JSON.parse(colItem.defaultInfo) : '';//因为这里的默认值是一个json对象
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        /* 地址组件中 moduleDefinition 返回参数：area：地区optionId  city：城市optionId  street：街道，详细地址optionId  province：省份optionId      "{"area": 49149, "city": 49148, "street": 49150, "province": 49147}"
        *  地址组件参数保存格式
        * "[{"areaId ":110102,"name ":"西城区 ","optionId ":49149,"type ":"area "}, 根据type 区分省市区详细地址，optionId是moduleDefinition里面带过来的id， areaId是地址的id，详细地址不用传
        * {"areaId ":110100,"name ":"北京市 ","optionId ":49148,"type ":"city "},
        * {"areaId ":"","name ":"按时发撒 ","optionId ":49150,"type ":"street "},
        * {"areaId ":110000,"name ":"北京 ","optionId ":49147,"type ":"province "}]",
        * 联动组件中 moduleDefinition 返回子条件和条件标题 但是格式是一维数组，需要前端整理成三维数组
        * 联动组件参数保存格式
        * "[{"id ":49170,"name ":"河南 ","level ":1,"parentId ":0},
        * {"id ":49171,"name ":"新乡 ","level ":2,"parentId ":49170},
        * {"id ":49175,"name ":"延津 ","level ":3,"parentId ":49171}]"
        * 我们统一把，联动组件的组建标题放到optionHead[] 里面，这里不仅保存着联动组件的标题，还表示了联动组件的层级
        * */
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionHead = [];
        column.optionList = [];
        column.defaultValue = column.defaultInfo;
        //当是联动组件的时候，进行子条件，默认值的特殊处理，联动租件没有默认值，所以可以不处理defaultValue
        if (column.moduleType == 15) {
          //遍历获取联动组件标题
          column.moduleDefinition.map(module=>{
            if (module.parentId == -1) {
              column.optionHead.push(module)
            }
          })
          //给组件标题按照层级高低排序
          column.optionHead = column.optionHead.sort(function (a, b) {
            return a.level - b.level;
          });
          //由于普通联动组件没有默认值，所以默认将组件标题作为默认值
          column.defaultValue = column.optionHead;
          //开始遍历，根据获取到的组件标题层级，将参数封装成多维数组
          let installChild =(data,item) => {
            if (item.parentId == data.id) {
              let child = item;
              child.children = [];
              data.children.push(child);
            } else {
              data.children.map(ite=>{
                installChild(ite, item)
              })
            }
          }
          column.moduleDefinition.map(condition=>{
            if (condition.parentId == 0) {
              let data = condition;
              data.children = [];
              column.optionList.push(data)
            } else if (condition.parentId > 0) {
              column.optionList.map(item=>{
                //调用函数，函数中递归，这样能组装不限制层级的多维数组
                installChild(item, condition)
              })
            }
          })
          column.value = []; //联动组件没有默认值，所以value默认也为空
        } else {//当是地址组件的时候，进行子条件，默认值的特殊处理
          //地址组件的联动标题是写死的
          column.optionHead = [
            {
              id: -1,
              level: 1,
              name: "选择省份",
              parentId: -1,
              optionId: column.moduleDefinition.province,
              type: 'province'
            },
            {
              id: -1,
              level: 2,
              name: "选择城市",
              parentId: -1,
              optionId: column.moduleDefinition.city,
              type: 'city'
            },
            {
              id: -1,
              level: 3,
              name: "选择地区",
              parentId: -1,
              optionId: column.moduleDefinition.area,
              type: 'area'
            },
            {
              id: -1,
              level: 4,
              name: "详细地址",
              parentId: -1,
              optionId: column.moduleDefinition.street,
              type: 'street'
            },
          ];
          column.optionList = cityMap;//地址组件的数据存在前端的静态数据当中。
          //如果地址组件的默认值没有设置，则将联动标题当作默认值
          if (column.defaultValue.length <= 0) {
            column.defaultValue = column.optionHead;
            column.value = []; //地址组件没有默认值的时候，value不能采取联动标题
          } else {
            column.value = [];
            column.defaultValue.map(value=>{//当地址组件有默认值的时候，将value也复制为默认值,由于数据是无序的所以需要排序
              let val = {
                id: value.areaId,
                name: value.name,
              };
              switch (value.type) {
                case 'province': {
                  column.value[0] = val;
                  break;
                }
                case 'city': {
                  column.value[1] = val;
                  break;
                }
                case 'area': {
                  column.value[2] = val;
                  break;
                }
                case 'street': {
                  column.value[3] = val;
                  break;
                }
              }
            })
          }
        }
        break;
      }
      //该类型组件都是标签组件 behavior:label 》自定义组件位置 js/component/bNiuLabel/bNiuLabel.js
      case 34: //标签 标签组件数据格式简单，只是交互和行为有些特殊
      {
        column.behaviorType = 'label';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = column.moduleDefinition;
        column.defaultValue = column.defaultInfo;
        column.value = []; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是子订单组件 behavior:childOrder 》自定义组件位置 js/component/bNiuChildOrder/bNiuChildOrder.js
      case 35: //子订单 childOrder
      {
        column.behaviorType = 'childOrder';
        column.defaultInfo = colItem.defaultInfo;
        column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
        column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
        column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
        column.optionList = [];
        column.moduleDefinition.map(col=>{
          col.extraInfo = JSON.parse(col.extraInfo)
          column.optionList.push(col)
        })
        column.defaultValue = [];
        column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
        break;
      }
      //该类型组件都是富文本组件 behavior:editor 》自定义组件位置 js/component/bNiuEditor/bNiuEditor.js
      // case 45: //富文本  富文本没有默认值
      // {
      //   column.behaviorType = 'editor';
      //   column.defaultInfo = colItem.defaultInfo;
      //   column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
      //   column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
      //   column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
      //   column.optionList = column.moduleDefinition;
      //   column.defaultValue = column.defaultInfo;
      //   column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
      //   break;
      // }
      //该类型组件都是子表单组件 behavior:childForm 》自定义组件位置 js/component/bNiuChildForm/bNiuChildForm.js
      // case 48: //子表单组件特殊处理，moduleDefinition中的数据不准确需要根据其中绑定的群组id重新请求数据 所以将这里的子条件和默认值都先放空
      // {
      //   column.behaviorType = 'childForm';
      //   column.defaultInfo = colItem.defaultInfo;
      //   column.extraInfo = colItem.extraInfo ? JSON.parse(colItem.extraInfo) : '';
      //   column.outDataSourceInfo = colItem.outDataSourceInfo ? colItem.outDataSourceInfo : '';
      //   column.moduleDefinition = colItem.moduleDefinition ? JSON.parse(colItem.moduleDefinition) : [];
      //   column.optionList = [];
      //   column.defaultValue = [];
      //   column.value = column.defaultValue; //当组件有默认值的时候，将value也复制为默认值
      //   break;
      // }

      //以下组件暂未定义过
      // case 14: //图片 image
      // {
      //   break;
      // }
      // case 16: //群成员 group
      // {
      //   break;
      // }
      // case 51: //erp订单号
      // case 52: //erp仓库
      // case 53: //erp订单数量
      // {break;}
    }
    if(column.behaviorType){
      columns.push(column);
    }
  })
  return columns;
};
/*
* 整理群组中的任务列表数据格式，将每条任务的值和组件列对应上去 参数 task：一条任务  column：已经组装好的群组的组件列表
* */
export function formattingTaskData (task, columns) {
  console.log(task)
  let taskInfo = {
    carryUser: {}, //指派人   执行人这里希望后端同学可以转化成有效的成员id 不要用2 1 0 这种代称
    carryUserColId:task.carryUserColId,//任务指派人组件id
    createUser: {}, //指派人
    deadline: task.deadline,//任务截止时间
    gmtCreate: task.gmtCreate,//任务创建时间
    id: task.id,//任务id
    isRead: task.isRead,//
    isStar: task.isStar,// 任务星标
    status: task.status,//任务状态
    statusColId: task.statusColId,//任务状态id
    taskContents: [], //任务内容
  }
  //遍历组件列，针对每种不同类型的组件进行赋值，没有值的组件，自动补为空
  columns.map(column=> {
      let data = column;
      delete data.moduleDefinition;
      delete data.value;
      for (let i in task.contents) {
        // 下拉菜单组件 behavior:select
        // 单选组件 behavior:radio
        // 字符串组件 behavior:string
        // 数值组件 behavior:number
        // 评分组件 behavior:score
        // 多选组件 behavior:checkbox
        // 标签组件 behavior:label
        // 日期组件 behavior:date
        // 日期区间组件 behavior:dateDual
        // 附件组件 behavior:file
        // 联动组件 behavior:relation
        // 富文本组件 behavior:editor
        // 购物车组件 behaviorType:shoppingCart
        // 子表单组件 behavior:childForm
        // 关联组件 behavior:relationTable

        // 子订单组件 behavior:childOrder
        data.oldValue = task.contents[i].value ? task.contents[i].value : '';
        if (task.contents[i].colId == column.id) {
          switch (column.behaviorType) {
            case "string": //以下类型的值可以直接使用
            case "score":
            case "number":
            case "editor"://富文本组件可以作为字符串处理
            case "date": //日期也可以作为字符串处理
            {
              if(task.contents[i].value){
                data.value = task.contents[i].value;
              }
              break;
            }
            case "label": //标签的值只传过来了一个 逗号隔开的id，不能在这里完成组装，！*******希望以后能把完整的数据放进来，就可以放到checkbox中做处理了
            {
              if(task.contents[i].value){
                let dataValue = task.contents[i].value.split(',');
                data.value = []
                dataValue.map(val=>{
                  data.value.push({title:val,id:val})
                });
              }
              break;
            }
            case "radio": //以下类型的值需要找到选项再赋值
            case "select": {
              let dataValue = {}
              for (let o in data.optionList) {
                if (task.contents[i].value == data.optionList[o].id) {
                  dataValue = data.optionList[o];
                  break;
                }
              }
              if(dataValue.title){
                data.value = dataValue;
              }
              break;
            }
            case "checkbox": //以下类型的值，需要进行特殊处理
            {
              let dataValue = [];
              data.optionList.map(option=>{
                if (task.contents[i].value.indexOf(option.id) >= 0) {
                  dataValue.push(option);
                }
              });
              if(dataValue.length>0){
                data.value = dataValue;
              }
              break;
            }
            case "dateDual": //日期区间的值需要拆分开
            {
              let dataValue = {}
              dataValue.start = task.contents[i].value.split(' ~ ')[0]
              dataValue.end = task.contents[i].value.split(' ~ ')[1]
              if(dataValue.start != '' || dataValue.end != ''){
                data.value = dataValue;
              }
              break;
            }
            case "relation":
            case "shoppingCart":
            case "childForm": //子表单的值比较特殊，一律放到自定义指令当中使用
            case "file": //附件、联动组件、购物车组件直接取value解析json
            {
              let dataValue = JSON.parse(task.contents[i].value);
              if(dataValue.length > 0){
                data.value = dataValue;
              }
              break;
            }
            case "childOrder": //子订单号组件
            {
              let dataValue = JSON.parse(task.contents[i].value);
              if(dataValue.length > 0){
                let dataArray = [];
                dataValue.map(dataVal=>{
                  let dataItem = {open:false,value:[{title:'子订单编号',value:dataVal.oid}]}
                  column.optionList.map(col=>{
                    if(col.extraInfo.hidden != '1' && col.isDisplayed){
                      dataItem.value.push({title:col.name,value:dataVal[col.key]})
                    }
                  })
                  dataArray.push(dataItem)
                })
                data.value = dataArray;
              }
        console.log(data.value)
              break;
            }
          }
          break;
        }
      }
      if(data.value){
        taskInfo.taskContents.push(data);
      }
    })
  console.log(taskInfo)
  return taskInfo;
}



// WEBPACK FOOTER //
// ./src/util/formattingProjectData.js